type UserRolesRef = {
  id: number;
  roles: string[];
};

/** Matches cabinet owner role pair used by UserContextFactory::resolveRealMemberType. */
export const isCabinetOwnerUser = (user: Pick<UserRolesRef, 'roles'>): boolean =>
  user.roles.includes('customer') && user.roles.includes('expert_comptable');

/** Mes utilisateurs delete is staff offboarding only — not self or cabinet owner. */
export const canDeleteUserFromList = (user: UserRolesRef, currentUserId: number): boolean =>
  user.id !== currentUserId && !isCabinetOwnerUser(user);
